export default [
  {
    key: 'endRepeat',
    label: 'label.endRepeat',
    type: 'date',
    resetButton: true,
    cols: 12
  }
];
